import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { collection, getDocs } from "firebase/firestore";
import { faCamera } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { db } from "../../firebase";
import committeeNamesData from '../../data/committee_names.json';
import PageHeading from '../PageHeading';
import Button from "../Button";

const RandomPortfolios = () => {
  const [portfolios, setPortfolios] = useState([]);
  const [randomPortfolios, setRandomPortfolios] = useState([]);

  useEffect(() => {
    const fetchPortfolios = async () => {
      try {
        const portfoliosRef = collection(db, "memberPortfolios");
        const querySnapshot = await getDocs(portfoliosRef);
        const portfolioData = querySnapshot.docs.map((doc) => ({
          id: doc.id,
          ...doc.data(),
        }));

        setPortfolios(portfolioData);
      } catch (error) {
        console.error("Error fetching portfolios: ", error);
      }
    };

    fetchPortfolios();
  }, []);

  useEffect(() => {
    if (portfolios.length > 0) {
      const shuffledPortfolios = [...portfolios].sort(
        () => 0.5 - Math.random()
      );
      const selectedPortfolios = shuffledPortfolios.slice(
        0,
        Math.min(3, portfolios.length)
      );
      setRandomPortfolios(selectedPortfolios);
    }
  }, [portfolios]);

  return (
    <div className="bg-white rounded-lg shadow-md p-6">
      <div className="container mx-auto pt-6">
        <PageHeading 
          heading="Featured Portfolios" 
          subheading="Check out some of our members' photography portfolios!"
        />
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8 bg-gradient-to-r from-[#60a4a4] to-[#4a7f7f] p-6 rounded-lg">
          {randomPortfolios.map((portfolio) => (
            <Link
              to={`/portfolios/${portfolio.portfolioLink}`}
              key={portfolio.id}
              className="bg-white rounded-lg shadow-xl overflow-hidden transform transition duration-500 hover:scale-105"
            >
              <div className="flex items-center justify-between p-4">
                <div className="flex-1">
                  <h3 className="text-3xl font-semibold text-gray-900 mb-1">
                    {portfolio.name}
                  </h3>
                  <p className="text-xl text-gray-600 mb-2">
                    {committeeNamesData.includes(portfolio.name) ? "Committee" : "Member"}
                  </p>
                  <div className="flex items-center text-sm text-gray-500">
                    <FontAwesomeIcon icon={faCamera} className="mr-2" />
                    <span>
                      {portfolio.galleries?.length || 0}{" "}
                      {portfolio.galleries?.length === 1
                        ? "Gallery"
                        : "Galleries"}
                    </span>
                  </div>
                </div>
                <div className="relative">
                  <img
                    className="h-20 w-20 lg:h-40 lg:w-40 sm:h-20 sm:w-20 object-cover rounded-full mx-auto"
                    src={portfolio.profileImage || "/fotosoc_logo_circle.png"}
                    alt={portfolio.name}
                  />
                </div>
              </div>
            </Link>
          ))}
        </div>

        <div className="p-4 text-center">
          <Button
                href="/portfolios"
                text="View All Portfolios"
                color="purple"
              />
        </div>
      </div>
    </div>
  );
};

export default RandomPortfolios;
